import namespace from '../../config/Namespace';

const types = {
  actions: {
    fetchAccounts: 'fetchAccounts',
    fetchAccountDetails: 'fetchAccountDetails',
    fetchAccountDetailsSuccess: 'fetchAccountDetailsSuccess',
    editAccount: 'editAccount',
    addAccountPhoto: 'addAccountPhoto',
    addAccountPhotoSuccess: 'addAccountPhotoSuccess',
    changePassword: 'changePassword',
    changePasswordSuccess: 'changePasswordSuccess',
    removeAccountPhoto: 'removeAccountPhoto',
    editProfile: 'editProfile',
    editProfileSuccess: 'editProfileSuccess',
    editProfileStarted: 'editProfileStarted',
    fetchRoles: 'fetchRoles',
    fetchRolesSuccess: 'fetchRolesSuccess',
    fetchCapabilities: 'fetchCapabilities',
    fetchCapabilitiesSuccess: 'fetchCapabilitiesSuccess',
    fetchPresets: 'fetchPresets',
    fetchPresetsSuccess: 'fetchPresetsSuccess',
    fetchMailGroups: 'fetchMailGroups',
    fetchMailGroupsSuccess: 'fetchMailGroupsSuccess',
  },
};

export default namespace('Accounts', types);
